import { Logger } from "../core/Logger.js";

/**
 *
 */
class Observer {
  constructor(tag, target) {
    this.handlers = [];
    this.tag = tag;

    // Use Proxy to watch the target object
    this.proxy = new Proxy(target, {
      set: (obj, prop, value) => {
        this.logChange('change', prop, obj[prop], value);
        obj[prop] = value;
        return true;
      },
      deleteProperty: (obj, prop) => {
        this.logChange('delete', prop, obj[prop], undefined);
        delete obj[prop];
        return true;
      },
    });
  }

  // Log the changes (could be improved for better debugging)
  logChange(action, prop, oldValue, newValue) {
    Logger.log(`Debugger (${this.tag}) -> action: ${action}, property: ${prop}, oldValue: ${oldValue}, newValue: ${newValue}`);
  }

  // Returns the proxy object
  getProxy() {
    return this.proxy;
  }
}

/**
 * The Debugger class provides a simple interface for observing changes to JavaScript objects.
 * It enables developers to track and log modifications to an object's properties
 */
export class Debugger {
  static watch = (tag, obj) => {
    // If obj is a primitive, wrap it in an object
    if (obj === null || typeof obj !== 'object') {
      obj = { value: obj };
    }

    const observer = new Observer(tag, obj);
    return observer.getProxy();
  };
}
